<template>
  <div class="v-input">
    <div class="v-input__control">
      <div class="v-input__slot">
        <VueRecaptcha
          v-if="siteKey"
          :sitekey="siteKey"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          @error="onCaptchaError"
        />
        <div v-else class="text-error">
          {{ $t('form.captchaSitekey') }}
        </div>
      </div>
      <div v-if="errors?.length > 0" class="v-text-field__details">
        <div class="v-messages theme--light text-error">
          <div class="v-messages__wrapper">
            <div class="v-messages__message">
              {{ errors?.[0] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate'
import { toRef, watch } from 'vue'
import { VueRecaptcha } from 'vue-recaptcha'

type Props = {
  rules: string | Record<string, unknown>
  required: boolean
  modelValue: string | null
  name: string
}

const props = defineProps<Props>()

const rulesRef = toRef(props, 'rules')

const { value, errors, resetField } = useField(() => props.name, rulesRef, {
  syncVModel: true
})

watch(value, () => {
  resetField()
})

function onCaptchaVerified(token: string) {
  value.value = token
}

function onCaptchaExpired() {
  value.value = null
}

function onCaptchaError() {
  value.value = null
}

const siteKey = import.meta.env.VITE_CAPTCHA_SITEKEY
</script>
